import logo from './logo.svg';
import './App.css';
import classNames from 'classnames';
import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';

function App() {
  const [logmix,setLogmix] = useState([]);
  const [images, setImages] = useState([]);
  const [logs, setLogs] = useState([]);
  const [serial, setSerial] = useState("");
  const [time, setTime] = useState(0);
  const [timeend, setTimeend] = useState(0);
  const [login, setLogin] = useState(false);
  const [pwd, setPwd] = useState("")
  const [ret, setRet] = useState({})
  const [currentpage, setCurrentpage] = useState(0)
  const CryptoJS = require("crypto-js");
  const key = CryptoJS.enc.Hex.parse("33303938333433323534363738393038");
  const [token,setToken] = useState("")

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const onSerial = (e) => setSerial(e.target.value);
  const onPwd = (e) => setPwd(e.target.value);
  const onTime = (e) => {
    var timestamp = new Date(e.target.value).getTime()/1000;
    setTime(timestamp);
  }
  const onTime1 = (e) => {
    var timestamp = new Date(e.target.value).getTime()/1000;
    setTimeend(timestamp);
  }
  const submitPwd = (e)=>{
    if(pwd == "dst3585"){
      setLogin(true);
      setDateRange(1);
      
       
        loadData();
     
    }
  }

  function encrypt(plainText, key, outputEncoding = "base64") {
 
    var iv = CryptoJS.lib.WordArray.create(0x0000000000000000, 128/8);
    return AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), key, {
      iv: iv, // Specify the IV here
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();  
  }

  function decrypt(cipherText, key) {
    return AES.decrypt(cipherText, key).toString(Utf8);  
  }

  function getPageCss(index){
    return  classNames({
      'page_item': true,
      'selected': (currentpage ) == index,
    });
  }
  useEffect(()=>{
    loadData();
  },[currentpage])

  useEffect(()=>{
    var ts = new Date().getTime().toString();
    const encrypt_str = encrypt(ts,key)
  
    
      const fetchData = async () => {
        try {
          // Initiate fetch request and await the response
          const response = await fetch(`https://ruvus5chq2.execute-api.us-east-2.amazonaws.com/token?serial=${ts}&chanellage=${encrypt_str}`);
          
          // Check if the request was successful
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
  
          // Extract JSON data and await it
          const jsonData = await response.text();
          
          // Update the state with the fetched data
          setToken(jsonData);
        } catch (error) {
          console.error("Error fetching data: ", error);
          
        }
      };
  
      // Call the fetchData function
      fetchData();


  },[])


  async function loadData() {
    let url;
      if(!time){
         var back = new Date().getTime()/1000 - ((new Date().getTime()/1000) % (24*3600));
        
           const timestamp = Date.now()/1000 ; // This could be any timestamp

         url = `https://ruvus5chq2.execute-api.us-east-2.amazonaws.com/events?logtoken=${token}&start=${back}&end=${timestamp}&skip=${currentpage ? currentpage * 100 : 0 }`;
      }
      else
         url = `https://ruvus5chq2.execute-api.us-east-2.amazonaws.com/events?logtoken=${token}&serial=${serial}&start=${time}&end=${timeend}&skip=${currentpage ? currentpage * 100 : 0 }`;
      if(!serial && time)
        url = `https://ruvus5chq2.execute-api.us-east-2.amazonaws.com/events?logtoken=${token}&start=${time}&end=${timeend}&skip=${currentpage ? currentpage * 100 : 0 }`;
    fetch(url)
      .then(res => res.json())
      .then(
        (result) => {
          if(result.ret){
            setRet(result)
            renderPage(result);
            setLogs(result.data);
          }
        },
        (error) => {
         
        }
      );
  
      
  }

  async function blend() {
    var logmix = [];
     images.forEach(image=>{
        // Convert the string to a Date object
        var item = {
          type:1,
          payload:image
        };
        logmix.push(item);

     });
  
    logs.forEach(log=>{
        var dateObj = new Date(log.timestamp);
        // Convert the Date object to a timestamp (in milliseconds)
        var timestamp = dateObj.getTime();
        // If you need the timestamp in seconds (like a Unix timestamp)
        var timestampInSeconds = timestamp / 1000;
        if(timestampInSeconds){
          log.create = timestampInSeconds;
          var item = {
            type:2,
            payload:log
          };
          logmix.push(item);
        }

     });

    logmix.sort(function(a, b) {
        return b.payload.create - a.payload.create;
    });

    setLogmix(logmix);
  }


  async function loadImage() {
      
    fetch(`https://ruvus5chq2.execute-api.us-east-2.amazonaws.com/images?logtoken=${token}&serial=${serial}&start=${time}&end=${timeend}`)
      .then(res => res.json())
      .then(
        (result) => {
          setRet(result)
          if(result.ret)
            setImages(result.data);
        },
        (error) => {
         
        }
      );
  
      
  }
  function getEventType(type){
    switch(type){
      case 0:
        return "Start";
      case 1:
        return "Stop";
      case 2:
        return "Set PSI";
      case 3:
        return "Set VAC";
    }
  }
  function formatTime(ts){
    let date = new Date(ts*1000);

// Format the date to 'YYYY-MM-DD HH:MM:SS'
    let formattedDate = date.getFullYear() + '-' +
                    ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
                    ('0' + date.getDate()).slice(-2) + ' ' +
                    ('0' + date.getHours()).slice(-2) + ':' +
                    ('0' + date.getMinutes()).slice(-2) + ':' +
                    ('0' + date.getSeconds()).slice(-2);

    return formattedDate;
  }
  function setDateRange(index){
    var back = new Date().getTime()/1000 - ((new Date().getTime()/1000) % (24*3600));

    if(index == 2)
      back -= 24*3600;
    if(index == 3)
      back -= 24*3600*7;
    if(index == 4)
      back -= 24*3600*1000;

    setTime(back);
    const dateStr = new Date(back* 1000).toISOString(back ).split('T')[0];
    setStartDate(dateStr);


    const timestamp = Date.now() ; // This could be any timestamp
    setTimeend(timestamp/1000);
    const dateStr1 = new Date(timestamp).toISOString().split('T')[0];
    setEndDate(dateStr1);
  }
  const handleSelectChange = (event) => {
    setDateRange(parseInt(event.target.value));
     
  };
  function onPage(index){
    setCurrentpage(index - 1);
 
  }

  function onPagePrev(index){
    if(currentpage)
      setCurrentpage(currentpage - 1);
 
  }

  function onPageNext(index){
    let page = ret.page;
      let total = ret.total;
      let pages = Math.ceil(total / ret.itemsperpage)

    if(currentpage < pages - 1)
      setCurrentpage(currentpage + 1);
 
  }
  function renderPage(){
    if(ret){
      let page = ret.page;
      let total = ret.total;
      let pages = Math.ceil(total / ret.itemsperpage)
      let pagesitem = [];
      for(var i = 1; i <= pages; i++){
        pagesitem.push(i);
      }
   
          
        //if(pages < 5)
          return <div class="pages">
            <span  class="page_item" onClick = {e=>onPagePrev()}> Prev </span>
            {pagesitem.map((page, j) =>
              <span class={getPageCss(j)} onClick = {e=>onPage(page)}>{page}</span>
            )}
            
            <span  class="page_item" onClick = {e=>onPageNext()}> Next </span>
            </div>
       
      
    }
    else
      return <div class="pages">
            <span>Prev</span>
            
            <span>Next</span>
            </div>
  }
  function renderRoot(){
    if(login){
      return <div>
          <div class="filter">
            <input type="text" class="serialnumber" placeholder="Serial Number" onChange={onSerial}/>
            <select name="range" id="range"  onChange={handleSelectChange}>
              <option value="1">TODAY</option>
              <option value="2">YESTERDAY</option>
              <option value="3">THIS WEEK</option>
              <option value="4">ALL</option>
            </select>
            <input type="date" placeholder="Time Range"  value={startDate} onChange={onTime}/>
            <input type="date" placeholder="Time Range"  value={endDate} onChange={onTime1}/>
            <input type="button" value="OK" onClick={e=>{loadData();}} />
          </div>
          <div class="records">
            <table>
              <th class="header">
                <td class="serial" >Serial</td>
                <td class="type">Action</td>
                <td class="printheadserial">Printhead Serial</td>
                <td class="printheadtype">Printhead Type</td>
                <td class="fluid">Fluid</td>
                <td class="program">Program</td>
                <td class="cycle">Cycle</td>
                <td class="psi">PSI</td>
                <td class="vac">VAC</td>
                <td class="us">US</td>
                <td class="time">DATE</td>
              </th>
              <tbody>
                {logs.map((log, j) =>
                  renderItem(log)
                )}
              </tbody>
            </table>
          </div>
          {renderPage()}
        </div>
    }
    else{
      return <div class="pwd">
        <input type="password" placeholder="Input access code" onChange={onPwd}/>
        <input type="button" value="OK" onClick={e=>{submitPwd()}} />
      </div>
    }
  }
  function renderItem(log){
    var dateObj = new Date(log.timestamp);
    var timestamp = dateObj.getTime();
    var timestampInSeconds = timestamp / 1000;

    if(log.eventype == 5)
      return <tr class="log_img">
        <td class="serial">{(log.serial)}</td>
        <td class="type">Took Photo</td>
        <td class="printheadserial">
          <a target="_blank" href={`https://phdappphotos.s3.us-east-2.amazonaws.com/${log.fn}`}><img src={`https://phdappphotos.s3.us-east-2.amazonaws.com/${log.fn}`} /></a>
        </td>
        <td class="printheadtype" colspan="5">{log.description}</td>
       
        <td class="us"></td>
        <td class="time">{formatTime(timestampInSeconds)}</td>
      </tr>
    else
      return <tr class="log_action">
        <td class="serial">{(log.serial)}</td>
        <td class="type">{getEventType(log.eventype)}</td>
        <td class="printheadserial">{log.printheadserial}</td>
        <td class="printheadtype">{log.printheadtype}</td>
        <td class="fluid">{log.fluid}</td>
        <td class="program">{log.program}</td>
        <td class="cycle">{log.cycle}</td>
        <td class="psi">{log.psi}psi</td>
        <td class="vac">{log.vac}hg</td>
        <td class="us">{log.ultrasound}%</td>
        <td class="time">{formatTime(timestampInSeconds)}</td>
      </tr>
  }

  return (
    <div className="App">
      
        {renderRoot()}
       
    </div>
  );
}

export default App;
